import { Map20Regular, FixedWidth20Regular, AgentsAdd20Regular, DocumentArrowRight20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const MapsOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const MapsCreatorPage = lazyPage(() => import('./tools/map-creator/pages/MapCreatorPage'));
const MapsFixedWidthPage = lazyPage(() => import('./tools/fixed-width-viewer/pages/FixedWidthPage'));

const mapsModuleConfig = createModuleConfig({
  key: 'maps',
  name: 'Maps',
  domain: { title: 'Maps', icon: Map20Regular },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Maps Overview',
      path: '/maps', 
      element: <MapsOverviewPage />, 
      nav: { name: 'Overview', icon: Map20Regular },
      shouldHide: true
    },
    { 
      key: 'map-creator',
      name: 'Map Creator',
      title: 'Map Creator',
      path: '/maps/map-creator', 
      element: <MapsCreatorPage />, 
      nav: { name: 'Map Creator', icon: AgentsAdd20Regular },
      shouldHide: true
    },
    { 
      key: 'fixed-width-viewer',
      name: 'Fixed Width Viewer',
      title: 'Fixed Width Viewer',
      path: '/maps/fixed-width-viewer', 
      element: <MapsFixedWidthPage />, 
      nav: { name: 'Fixed Width Viewer', icon: FixedWidth20Regular }
    },
    { 
      key: 'filename-rule-tester',
      name: 'Filename Rule Tester',
      title: 'Filename Rule Tester',
      path: '/maps/filename-rule-tester', 
      element: <MapsFixedWidthPage />, 
      nav: { name: 'Filename Rule Tester', icon: DocumentArrowRight20Regular },
      shouldHide: true
    },
  ],
});

export default mapsModuleConfig;
